import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { supabase } from '../lib/supabaseClient';

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  </div>
);

const GuestCheckoutRoute = ({ children }) => {
  const { user, loading: authLoading } = useSelector((state) => state.auth);
  const [allowGuestCheckout, setAllowGuestCheckout] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        // Get settings from the database
        const { data, error } = await supabase
          .from('settings')
          .select('allow_guest_checkout')
          .single();

        if (error && error.code !== 'PGRST116') {
          console.error('Error fetching settings:', error);
          // Default to true if there's an error
          setAllowGuestCheckout(true);
        } else {
          // If we have settings, use them, otherwise default to true
          setAllowGuestCheckout(data?.allow_guest_checkout ?? true);
        }
      } catch (err) {
        console.error('Error fetching settings:', err);
        // Default to true if there's an exception
        setAllowGuestCheckout(true);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  // Show loading spinner while checking auth state and fetching settings
  if (authLoading || loading) {
    return <LoadingSpinner />;
  }

  // If user is authenticated, render the protected content
  if (user) {
    return children;
  }
  
  // If guest checkout is allowed, render the protected content
  if (allowGuestCheckout) {
    return children;
  }

  // If user is not authenticated and guest checkout is not allowed,
  // redirect to login with a redirect parameter
  return <Navigate to="/login?redirect=checkout" replace />;
};

export default GuestCheckoutRoute; 